
import * as Connection from "../../src/connection";
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "ServerInOutPortsSelect",
  props: {
    modelValue: Number,
    excludeId: [Number],
    mode: {
      validator: function (value: string) {
        return ["in", "out"].indexOf(value) !== -1;
      },
    },
  },
  // eslint-disable-next-line 
  setup(props: any) {
    const inPorts = computed(() => {
      let ports = Connection.loginStatus.inPorts;
      if (props.mode === "out") {
        ports = Connection.loginStatus.outPorts;
      }
      const portsAry: { id: number; name: string }[] = [];
      Object.keys(ports).forEach((key) => {
        if (props.excludeId !== Number(key)) {
          portsAry.push({ id: Number(key), name: ports[Number(key)] });
        }
      });
      return portsAry;
    });
    
    return { inPorts };
  },
});
